// ADR 23.9.26v §6 — why a network-only control is disabled. Not a toast: it
// stays beside the control for exactly as long as the control is disabled.

import { useTranslation } from 'react-i18next'

import { Button } from '../ui/Button'
import { useOnlineStatus } from './onlineSignal'

/**
 * §5 — a list surface's pending line. Offline, an unrestored query stays
 * `pending` + `paused` forever, so `loading` would be a lie; the page says
 * there is nothing cached instead.
 */
export function PendingLine() {
  const { t } = useTranslation()
  const online = useOnlineStatus()
  return <p className="text-sm text-ink-muted">{t(online ? 'loading' : 'error_offline_no_cache')}</p>
}

/**
 * ADR 2.10.26s §6 — a list surface's rejected read with nothing cached. Not
 * the empty state ("you have no plans" is a lie about a failure) and not the
 * loading line (which would never end): the one line and a Retry of the read,
 * network-only like every other network action (23.9.26v §6).
 */
export function QueryFailedLine({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation()
  const online = useOnlineStatus()
  return (
    <div className="space-y-2" data-testid="query-failed">
      <p role="alert" className="text-sm text-ink-muted">{t('error_unknown')}</p>
      <Button disabled={!online} onClick={onRetry}>{t('exercise_retry')}</Button>
      <OfflineHint />
    </div>
  )
}

/** `error_check_connection` under a control, offline only. */
export function OfflineHint() {
  const { t } = useTranslation()
  const online = useOnlineStatus()
  if (online) return null
  return (
    <p role="note" className="text-sm text-ink-muted">
      {t('error_check_connection')}
    </p>
  )
}
